const windowUrl = window.location.href;
const isLocal = windowUrl.match(/localhost/);

export const baseURL = isLocal
  ? "https://0xzdpile39.execute-api.us-east-2.amazonaws.com/qa"
  : process.env.REACT_APP_BASEURL;

export default { baseURL };
